export default __webpack_public_path__ + "static/media/ga-login1.9bd61861.svg";